export enum PrimaryClientType {
  Client = 'Client',
  LegalClient = 'LegalClient',
}
